/* eslint-disable import/prefer-default-export */
import fetchRequest from '../../helpers/fetchRequest';

export async function getActiveSlides() {
  const url = '/active-slides';
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  return fetchRequest(url, options);
}

export async function getSocialLinks() {
  const url = '/active-slides/socials';
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  return fetchRequest(url, options);
}

export async function getLeftBanner() {
  const url = '/left-banner';
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };
  return fetchRequest(url, options);
}
